import OrderInformation from "./OrderInformation";

export default OrderInformation;
